// extracted by mini-css-extract-plugin
module.exports = {"note":"_2hhckx"};